import Vue from 'vue'

//Rotas do aplicativo
import router from './router/router'

//Components
import './components'
import './shared/components'

//Plugins
import './plugins'
import vuetify, { loadSavedTheme } from '@/plugins/vuetify'

import '@/assets/styles/global.css'

// Carrega tema salvo ou preferência do sistema
loadSavedTheme()

//Filters
import './filters'

//Helpers
import './helpers'

//Home App
import App from './App.vue'

//Vuex
import store from './store'

Vue.config.productionTip = false
// Inicializa app Vue
if (process.env.NODE_ENV === 'production') {
  import('./analytics').then(mod => { if(mod && typeof mod.default === 'function') mod.default(); }).catch(() => {});
}

window._Vue = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

